import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

function resolveCoords(params: any, systems: any): [number, number] {
  if (params.infraId && systems.city) {
    const pos = systems.city.getInfraPosition(params.infraId);
    if (pos) return pos;
  }
  return params.coordinates;
}

export function registerPanelSteps(registry: StepRegistry): void {
  registry.register('show-panel', async (step, systems, runner) => {
    const params = step.params;

    // Resolve infra position
    params.coordinates = resolveCoords(params, systems);

    // If camera is following a vehicle, show panel at that vehicle's position
    const vid = runner.followingVehicleId;
    if (vid) {
      const vehiclePos = systems.vehicles.getPosition(vid);
      if (vehiclePos) {
        params.coordinates = vehiclePos;
      }
    }

    systems.panels.show(params);

    // Track the followed vehicle's position
    if (vid) {
      systems.panels.trackPosition(params.id, () =>
        systems.vehicles.getPosition(vid!) || params.coordinates
      );
    }

    await wait(step.duration);
  });

  registry.register('remove-panel', async (step, systems) => {
    systems.panels.remove(step.params.id);
    await wait(step.duration);
  });

  registry.register('update-panel', async (step, systems) => {
    systems.panels.update(step.params.id, step.params.data);
    await wait(step.duration);
  });
}
